export const SET_STAGE = 'SET_STAGE';

export const setNavigationStage = (stage) => ({
    type: SET_STAGE,
    payload: {
        stage: stage
    }
})
